import React, { useEffect, useState } from "react";
import CinematicGlassShowcase from "./CinematicGlassShowcase";
import { Tabs } from "./styles";
import type { CarouselItem } from "./types";

export type { CarouselItem };

export default function Projects() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [selectedTabs, setSelectedTabs] = useState<string[]>(["All"]);

  const RobotSimulationImg = require("../../../assets/videos/robot-simulation/poster.svg");
  const GCAssistImg = require("../../../assets/videos/gc-assist/poster.png");
  const HoloworkAssistImg = require("../../../assets/videos/holowork-assist/poster.png");
  const ArgoHytosARImg = require("../../../assets/videos/argo-hytos/t1.png");
  const RyllmesseImg = require("../../../assets/videos/ryllmesse/poster.png");
  const PilkingtonARImg = require("../../../assets/videos/pilkington/poster.png");
  const SaackeScrubberImg = require("../../../assets/videos/saacke-scrubber/poster.png");
  const ConelWebImg = require("../../../assets/videos/conel-web/poster.png");
  const StolpersteinImg = require("../../../assets/videos/stolperstein-nrw/banner.jpg");
  const BremerhavenGuideImg = require("../../../assets/videos/bremerhaven-guide/t3.png");
  const BremenGoImg = require("../../../assets/videos/bremen-go/t3.png");
  const QualifyARImg = require("../../../assets/videos/qualify-ar/Poster_QualifyAR.png");
  const ARConnectImg = require("../../../assets/videos/ar-connect/poster.png");
  const HoloConnectImg = require("../../../assets/videos/holo-connect/poster.png");
  const BarCelonaImg = require("../../../assets/videos/bar-celona/poster.png");
  const HoloWorkImg = require("../../../assets/videos/holowork/poster.png");

  const items: CarouselItem[] = [
    {
      id: 1,
      src: HoloWorkImg,
      name: "Holo Work",
      linkTo: "/HoloWork",
      categories: ["Mixed Reality", "Multi-User"],
    },
    {
      id: 2,
      src: BarCelonaImg,
      name: "Bar Celona AR Menu",
      linkTo: "/BarCelona",
      categories: ["WebAR"],
    },
    {
      id: 3,
      src: BremenGoImg,
      name: "Bremen Go",
      linkTo: "/BremenGo",
      categories: ["Augmented Reality"],
    },
    {
      id: 4,
      src: QualifyARImg,
      name: "Qualify AR",
      linkTo: "/QualifyAR",
      categories: ["Augmented Reality", "Desktop"],
    },
    {
      id: 5,
      src: BremerhavenGuideImg,
      name: "Bremerhaven Guide",
      linkTo: "/BremerhavenGuideIOS",
      categories: ["Augmented Reality"],
    },
    {
      id: 6,
      src: ConelWebImg,
      name: "Conel Web",
      linkTo: "/ConelWeb",
      categories: ["WebGL", "3D Modelling"],
    },
    {
      id: 7,
      src: PilkingtonARImg,
      name: "Pilkington AR",
      linkTo: "/PilkingtonAR",
      categories: ["Augmented Reality"],
    },
    {
      id: 8,
      src: StolpersteinImg,
      name: "Stolperstein NRW",
      linkTo: "/StolpersteinNRW",
      categories: ["Augmented Reality"],
    },
    {
      id: 9,
      src: SaackeScrubberImg,
      name: "Saacke Scrubber",
      linkTo: "/Saacke-Scrubber",
      categories: ["WebGL", "Desktop"],
    },
    {
      id: 10,
      src: ARConnectImg,
      name: "AR Connect",
      linkTo: "/ARConnect",
      categories: ["Augmented Reality", "Multi-User"],
    },
    {
      id: 11,
      src: HoloConnectImg,
      name: "Holo Connect",
      linkTo: "/HoloConnect",
      categories: ["Mixed Reality"],
    },
    {
      id: 12,
      src: RyllmesseImg,
      name: "Ryll Messe",
      linkTo: "/RyllMesse",
      categories: ["Mixed Reality", "Multi-User"],
    },
    {
      id: 13,
      src: ArgoHytosARImg,
      name: "Argo Hytos AR",
      linkTo: "/ArgoHytosAR",
      categories: ["Augmented Reality"],
    },
    {
      id: 14,
      src: HoloworkAssistImg,
      name: "HOLOWORK ASSIST",
      linkTo: "/HoloworkAssist",
      categories: ["Augmented Reality", "Mixed Reality", "WebGL"],
    },
    {
      id: 15,
      src: GCAssistImg,
      name: "GC Assist",
      linkTo: "/GCAssist",
      categories: ["Virtual Reality", "Augmented Reality", "WebGL"],
    },
    {
      id: 16,
      src: RobotSimulationImg,
      name: "Virtual Reality Robot training application (Prototype)",
      linkTo: "/RobotSimulation",
      categories: ["Virtual Reality"],
    },
  ];

  const handleTabClick = (tabName: string) => {
    if (tabName === "All") {
      setSelectedTabs(["All"]);
    } else {
      setSelectedTabs((prev) => {
        // If "All" is currently selected, replace it with the new tab
        if (prev.includes("All")) {
          return [tabName];
        }
        // If the tab is already selected, remove it
        if (prev.includes(tabName)) {
          const newTabs = prev.filter((tab) => tab !== tabName);
          // If no tabs are selected, default to "All"
          return newTabs.length > 0 ? newTabs : ["All"];
        }
        // Otherwise, add the new tab
        return [...prev, tabName];
      });
    }
    setCurrentSlide(0);
  };

  const filterKey = selectedTabs.join("|");

  const filteredItems = selectedTabs.includes("All")
    ? items
    : items.filter((item) =>
        item.categories.some((category) => selectedTabs.includes(category)),
      );

  useEffect(() => {
    setCurrentSlide((s) => Math.min(s, Math.max(0, filteredItems.length - 1)));
  }, [filteredItems.length, filterKey]);

  const isTabActive = (tabName: string) => {
    return selectedTabs.includes(tabName);
  };

  return (
    <div className="flex-grow-1 bg-black pt-3 pt-sm-4">
      <div className="row m-0 justify-content-center text-center">
        <div className="col-12 px-0 px-sm-4 px-md-5 pt-1">
          <Tabs>
            <ul className="animate__animated animate__fadeInDown">
              <li
                onClick={() => handleTabClick("All")}
                className={isTabActive("All") ? "active" : ""}
              >
                All
              </li>
              <li
                onClick={() => handleTabClick("Augmented Reality")}
                className={isTabActive("Augmented Reality") ? "active" : ""}
              >
                Augmented Reality
              </li>
              <li
                onClick={() => handleTabClick("Mixed Reality")}
                className={isTabActive("Mixed Reality") ? "active" : ""}
              >
                Mixed Reality
              </li>
              <li
                onClick={() => handleTabClick("Virtual Reality")}
                className={isTabActive("Virtual Reality") ? "active" : ""}
              >
                Virtual Reality
              </li>
              <li
                onClick={() => handleTabClick("Multi-User")}
                className={isTabActive("Multi-User") ? "active" : ""}
              >
                Multi-User
              </li>
              <li
                onClick={() => handleTabClick("WebGL")}
                className={isTabActive("WebGL") ? "active" : ""}
              >
                WebGL
              </li>
              <li
                onClick={() => handleTabClick("WebAR")}
                className={isTabActive("WebAR") ? "active" : ""}
              >
                WebAR
              </li>
              <li
                onClick={() => handleTabClick("Desktop")}
                className={isTabActive("Desktop") ? "active" : ""}
              >
                Desktop
              </li>
              <li
                onClick={() => handleTabClick("3D Modelling")}
                className={isTabActive("3D Modelling") ? "active" : ""}
              >
                3D Modelling
              </li>
            </ul>
          </Tabs>
        </div>
      </div>

      {filteredItems.length > 0 ? (
        <CinematicGlassShowcase
          key={filterKey}
          items={filteredItems}
          activeIndex={Math.min(currentSlide, filteredItems.length - 1)}
          onSlideChange={setCurrentSlide}
        />
      ) : (
        <div className="text-center text-white py-5">
          No projects found for the selected categories.
        </div>
      )}

      {/* {selectedTab === "AR Development" && (
        <div>Content for AR Development tab</div>
      )}
      {selectedTab === "VR Development" && (
        <div>Content for VR Development tab</div>
      )}
      {selectedTab === "Web AR" && <div>Content for Web AR tab</div>}
      {selectedTab === "3D Modelling" && (
        <div>Content for 3D Modelling tab</div>
      )} */}
    </div>
  );
}
